import HomeSummary from './HomeSummary';

export default HomeSummary;
